<template>
  <div v-if="options && options.length" class="btn-group btn-block" role="group">
    <button
      data-submit-button="true"
      type="button"
      v-bind:disabled="state.loading"
      v-on:click="send"
      class="btn btn-block btn-primary btn-lg"
    >
      <i v-if="state.loading" class="fas fa-spinner fa-spin pull-right"></i>
      <span v-else>{{label}}</span>
    </button>
    <div class="btn-group" role="group">
      <button
        type="button"
        class="btn btn-primary btn-lg dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      ></button>
      <div class="dropdown-menu">
        <div class="dropdown-arrow"></div>
        <a
          v-for="option in options"
          @click="() => sendOption(option)"
          :key="option.id"
          class="dropdown-item"
          href="javascript:void(0);"
        >{{option.label}}</a>
      </div>
    </div>
  </div>
  <button
    v-else
    data-submit-button="true"
    type="button"
    v-bind:disabled="state.loading"
    class="btn btn-primary btn-lg btn-block"
    v-on:click="send"
  >
    <b-icon v-if="state.loading" icon="three-dots" animation="cylon"></b-icon>
    <span v-else>{{label}}</span>
  </button>
</template>

<script>
const store = {
  state: {
    loading: false,
  },
};

export default {
  data: function() {
    return store;
  },
  computed: {},
  beforeMount: function() {},
  props: ['label', 'action', 'options'],
  methods: {
    send: async function() {
      store.state.loading = true;
      await this.action();
      store.state.loading = false;
    },
    sendOption: async function(option) {
      store.state.loading = true;
      await option.action();
      store.state.loading = false;
    },
  },
  components: {},
};
</script>